import { Component, Optional, inject } from '@angular/core';
import { ItemWithSelection } from '@app/shared/models/item-with-selection';
import {
  ActionResult,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  Util,
  ViewState,
  ViewWindow,
  WindowRegistry
} from '@ntap/core';
import { EMPTY, Observable, map, switchMap } from 'rxjs';
import { OpenDialogItemsListActionComponent } from '../items-list-action/open-dialog-items-list-action.component';
import { CommonConfirmActionService } from '@app/services/common-confirm-action.service';
import { isDisabledActionForNerazvrstano } from '@app/shared/util/jedinica-gradiva-security-utils';

@Component({
  selector: 'app-izlucivanje-action',
  templateUrl: './izlucivanje-action.component.html'
})
export class IzlucivanjeActionComponent extends OpenDialogItemsListActionComponent {
  public commonConfirmActionService = inject(CommonConfirmActionService);

  key = 'newIzlucivanje' + this.toString;

  constructor(
    protected override notificationService: NotificationService,
    protected override windowRegistry: WindowRegistry,
    @Optional() protected override window: ViewWindow,
    protected override listViewProvider: ListViewProviderDirective<ListView>
  ) {
    super(notificationService, windowRegistry, window, listViewProvider);
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        this.someSelectedUIzlucivanju = selectedItems.some((item: any) => {
          const mainType =
            item[NtapGlobalConstants.ATTR_$itemType] ||
            item[NtapGlobalConstants.ATTR_$mainType];
          const statusIzlucivanja =
            item[Util.getFullAttrName(mainType, 'status_izlucivanja')];
          const rezidualniPodaci =
            item[Util.getFullAttrName(mainType, 'rezidualni_podaci')];
          return (
            (!!statusIzlucivanja || rezidualniPodaci) &&
            statusIzlucivanja != 'OBUSTAVLJENO_IZLUCIVANJE'
          );
        });
        if (this.someSelectedUIzlucivanju) {
          this.tooltip =
            'Odabrali ste jedinice koje su već u procesu izlučivanja ili su rezidualne';
        } else {
          this.tooltip = null;
        }
        return (
          !selectedItems ||
          (!!selectedItems && selectedItems.length == 0) ||
          this.someSelectedUIzlucivanju ||
          isDisabledActionForNerazvrstano(selectedItems)
        );
      })
    );
  }

  protected override getInitialState(
    selectedItems: object[]
  ): ViewState & ItemWithSelection {
    return Object.assign(
      {},
      {
        $addPodjedinice: true,
        'en~izlucivanje~id': 0,
        $selected: Util.mapToBasicItemData(selectedItems),
        $listName: this.listViewProvider.viewName,
        $filterCriteria: (this.listViewProvider?.viewState as any)?.[
          '$filterCriteria'
        ]
      }
    );
  }

  protected override doExecute(): Observable<ActionResult> {
    return this.commonConfirmActionService.confirm(this.key).pipe(
      switchMap(({ confirmed }) => {
        if (confirmed) {
          return super.doExecute();
        }
        return EMPTY;
      })
    );
  }
}
